import { render, staticRenderFns } from "./PdfPluginViewer.vue?vue&type=template&id=dc71dec6&scoped=true&"
import script from "./PdfPluginViewer.vue?vue&type=script&lang=ts&"
export * from "./PdfPluginViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PdfPluginViewer.vue?vue&type=style&index=0&id=dc71dec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc71dec6",
  null
  
)

export default component.exports